import { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAuthStore from './stores/authStore';
import { routes } from './routes';
import BaseLayout from './components/layout/BaseLayout';
import PrivateRoute from './routes/PrivateRoute';
import LoadingSpinner from './components/common/LoadingSpinner';
import './styles/globals.css';

function App() {
  const checkAuth = useAuthStore(state => state.checkAuth);
  const isLoading = useAuthStore(state => state.isLoading);

  useEffect(() => {
    const initAuth = async () => {
      try {
        const success = await checkAuth();
        if (!success) {
          console.log('Usuário não autenticado');
        }
      } catch (error) {
        console.error('Erro ao verificar autenticação:', error);
      }
    };

    initAuth();
  }, [checkAuth]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const renderRoutes = (routeList, role) => {
    return routeList.map((route) => {
      const Element = route.element;
      const Layout = route.layout === 'base' ? BaseLayout : PrivateRoute;

      // Rota principal
      const mainRoute = (
        <Route
          key={route.path}
          path={route.path}
          element={
            <Layout requiredRole={role}>
              <Suspense fallback={<LoadingSpinner />}>
                <Element />
              </Suspense>
            </Layout>
          }
        />
      );

      // Rotas filhas (se existirem)
      const childRoutes = route.children?.map((child) => {
        const ChildElement = child.element;
        return (
          <Route
            key={`${route.path}/${child.path}`}
            path={`${route.path}/${child.path}`}
            element={
              <Layout requiredRole={role}>
                <Suspense fallback={<LoadingSpinner />}>
                  <ChildElement />
                </Suspense>
              </Layout>
            }
          />
        );
      });

      return [mainRoute, ...(childRoutes || [])];
    }).flat();
  };

  return (
    <Router>
      <Suspense fallback={<LoadingSpinner />}>
        <ToastContainer />
        <Routes>
          {/* Rotas Públicas */}
          {renderRoutes(routes.public)}

          {/* Rotas Protegidas */}
          {renderRoutes(routes.protected)}

          {/* Rotas de Admin */}
          {renderRoutes(routes.admin, 'ADMIN')}

          {/* Rotas de Usuário */}
          {renderRoutes(routes.user, 'USER')}

          {/* Rotas de Cliente */}
          {renderRoutes(routes.client, 'CLIENT')}

          {/* Rota padrão */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
